import AbstractPiniaModel from './AbstractPiniaModel'
import { useMainCategoriesStatsStore } from '../pinia/stores/mainCategoriesStats'
import Api from 'Ajax'
import { checkApiResponseForAuth } from '@features/_common/errorHandler'

export class MainCategoriesStats extends AbstractPiniaModel {
    constructor() {
        super()
    }

    static piniaStore() {
        return useMainCategoriesStatsStore()
    }

    static existsFor(professionID, mainCategoryID) {
        return this.piniaStore().existsMainCategoriesStatsFor({
            professionID,
            mainCategoryID,
        })
    }

    static loadAllFromBackendFor(
        professionID, addSubCategories = false
    ) {
        const id = Number(professionID)
        if (!Number.isFinite(id) || id <= 0) {
            return Promise.resolve(false)
        }

        return Api.getAllMainCategoriesStatsFor(id, addSubCategories)
            .then((result) => {
                Object.entries(result.data).forEach(([mainCategoryID, stats]) => {
                    this.dispatch('addToMainCategoriesStats', {
                        professionID: id,
                        mainCategoryID: parseInt(mainCategoryID, 10),
                        stats: stats,
                    })
                })
                return true
            })
            .catch((err) => {
                checkApiResponseForAuth(this.ebus(), err)
                return false
            })
    }

    static getFor(professionID, mainCategoryID, addSubCategories = false) {
        return this.piniaStore().getMainCategoriesStatsFor({
                professionID,
                mainCategoryID,
        })
    }
}
